module.exports = __webpack_public_path__ + "static/media/GB.d5216cbf.svg";